/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".progress[_ngcontent-%COMP%]{border-radius:0 1px 1px 0;display:flex;align-items:center;height:4px;width:100%}.progress__bar[_ngcontent-%COMP%]{background:#de3838;height:100%;width:0;transition:width .25s}"];
export { styles as styles };
